import { Diversity3Outlined } from "@mui/icons-material";

const civilServiceResource = {
    title: "Civil Service Eligibility",
    singular: "Civil Service",

    collectionField: "civilServices",
    displayField: "accreditation",
    icon: Diversity3Outlined,

    columns: [
        { field: "accreditation", header: "Accreditation", type: "text" },
        { field: "dateTaken", header: "Date Taken", type: "date" },
        { field: "placeTaken", header: "Place Taken", type: "text" },
        { field: "licenseNumber", header: "License Number", type: "text" },
        { field: "validityDate", header: "Validity Date", type: "date" }
    ],

    fields: {
        accreditation: {
            name: "accreditation",
            label: "Accreditation",
            type: "text",
            required: true
        },
        dateTaken: {
            name: "dateTaken",
            label: "Date Taken",
            type: "date",
            required: true
        },
        placeTaken: {
            name: "placeTaken",
            label: "Place Taken",
            type: "text"
        },
        licenseNumber: {
            name: "licenseNumber",
            label: "License Number",
            type: "text"
        },
        validityDate: {
            name: "validityDate",
            label: "Validity Date",
            type: "date"
        }
    }
};

export default civilServiceResource;
